export const loadExternalScript = (
  src: string,
  id: string,
): void => {
  if (document.getElementById(id)) {
    return;
  }

  const script = document.createElement("script");

  script.id = id;
  script.src = src;
  script.async = true;

  document.head.insertBefore(script, document.head.firstChild);
};